var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"map-modal-ref",staticStyle:{"border":"1px solid red","margin-top":"150px","position":"absolute","top":"80px"},attrs:{"id":"map-modal","hide-footer":"","title":"Map"}},[_c('Map',{ref:"map-ref"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }